import {connect} from 'react-redux'
import {RootState} from '../../common/redux/store'
import TestBasedSelection from '../components/TestBasedSelection'

const mapStateToProps = (state: RootState) => ({
  testType: state.selection.testType,
})

export default connect(mapStateToProps)(TestBasedSelection)
